import { Button } from "@mui/material";
import React from "react";

function EditSchool({ setActionComponent, currentSchoolId }) {
  return (
    <div>
      EditSchool
      <Button color="error" onClick={() => setActionComponent(null)}>
        Cancel
      </Button>
    </div>
  );
}

export default EditSchool;
